import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as AccessibleIcon from '@radix-ui/react-accessible-icon';
import { gettext } from '../utils/text';

const setCookie = (name, value, maxAge) => {
    document.cookie = `${name}=${value}; max-age=${maxAge}; path=/`;
};

const getCookie = (name, value) => {
    return document.cookie.includes(`${name}=${value}`);
};

const AlertWindow = ({ data }) => {
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Bootstrap md breakpoint
    const MOBILE_BREAKPOINT = 768;

    useEffect(() => {
        if (!getCookie('alertPopup', false)) {
            setIsAlertOpen(true);
        }
    }, []);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        };

        checkMobile();

        window.addEventListener('resize', checkMobile);

        // Cleanup
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const closeWindow = () => {
        setCookie('alertPopup', 'false', 1800);
        setIsAlertOpen(false);
    };

    const showOnMobile = data.showOnMobile === 'True';
    const shouldShowAlert = isAlertOpen && (showOnMobile || !isMobile);

    return (
        <>
            {shouldShowAlert ? (
                <div
                    role="region"
                    className="alert-window"
                    aria-labelledby="alert-window-title"
                    aria-describedby="alert-window-message"
                    aria-live="polite"
                    aria-atomic="true"
                >
                    <button
                        type="button"
                        className="close-button"
                        onClick={() => {
                            closeWindow();
                        }}
                        aria-label={gettext('Close alert')}
                    >
                        <AccessibleIcon.Root label={gettext('Close alert')}>
                            <span aria-hidden="true">&times;</span>
                        </AccessibleIcon.Root>
                    </button>
                    <h2 id="alert-window-title">
                        {data.title !== 'None' ? data.title : ''}
                    </h2>
                    <br />
                    <p id="alert-window-message">{data.message}</p>
                    {data.link && (
                        <button
                            className="btn btn-primary confirm-button"
                            type="button"
                            onClick={() => {
                                closeWindow();
                                window.open(data.link, '_blank');
                            }}
                        >
                            {data.button}
                        </button>
                    )}
                </div>
            ) : (
                <div />
            )}
        </>
    );
};

AlertWindow.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        button: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        showOnMobile: PropTypes.string.isRequired,
    }).isRequired,
};

export default AlertWindow;
